<div class="icon" tabindex="-1">
  <span [style.color]="color" [class]="css" tabindex="-1"></span>
</div>
